import { memo, useEffect, useState } from "react";
import { Button } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import MyDateTime from "../../../DTechComp/MyDateTime";
import OrderFunctions from "../../../OrderSettings/OrderFunctions";

// טיימר עצמאי לשורת הזמנה פתוחה בצד הלקוח - מחזיק setInterval משלו וקורא
// תמיד את ה-ord העדכני שמתקבל כ-prop, במקום snapshot קפוא שנתפס פעם אחת
// בזמן בניית interval מרכזי (MyOrders.startHandler הישן, שהתבסס על
// getElementById/innerText וגרם לסטטוס לא להתעדכן בזמן אמת).
// מחליף את שלושת ה-<div> עם id דינמי:
//   `${orderNUM}`        - הטיימר עצמו / טקסט הסטטוס בהזמנה סגורה
//   `${orderNUM}_GR`     - התווית "נהיה מוכנים בעוד" / "סטטוס"
//   `${orderNUM}_Ended`  - המצב "ממתין לאיסוף" / "תיכף מגיע"

const CLOSED_LIKE = ["סגור", "מושהה", "מבוטל", "בקשה לסגירה", "בקשה לביטול"];

// hook פנימי - טיק כל שנייה בלי לגרום ל-re-render להורה
const useSecondTick = () => {
    const [, forceTick] = useState(0);
    useEffect(() => {
        const id = setInterval(() => forceTick((t) => t + 1), 1000);
        return () => clearInterval(id);
    }, []);
};

const MyOrderTimerCell = memo(({ ord, timerCss, grCss, endedCss }) => {
    useSecondTick();

    const isTakeAway = ord.OrderType === "Take";
    const grBaseTxt = isTakeAway ? "נהיה מוכנים בעוד" : "נגיע בעוד";
    const endedTxt = isTakeAway ? "ממתין לאיסוף" : "תיכף מגיע";

    // הזמנה סגורה / מושהית / מבוטלת / בקשה לסגירה-ביטול -
    // מציגים טקסט סטטוס במקום טיימר
    if (CLOSED_LIKE.includes(ord.orderStatus)) {
        return (
            <>
                <div className={grCss}>סטטוס </div>
                <div className={timerCss}>
                    {OrderFunctions.getClientFriendlyStatus(ord.orderStatus)}
                </div>
            </>
        );
    }

    let theItm = MyDateTime.getTimeLeftTilThen(
        ord.scheduledFor || ord.dateCreated,
        ord.OrderTimes
    );
    if (theItm.theTm.split(":").length < 2) {
        theItm.theTm = "00:" + theItm.theTm;
    }

    // עדיין בזמן - מציגים ספירה לאחור
    if (!theItm.theEnd) {
        return (
            <>
                <div className={grCss}>{grBaseTxt}</div>
                <div className={timerCss}>{theItm.theTm}</div>
            </>
        );
    }

    // חלף המועד - מציגים "ממתין לאיסוף" / "תיכף מגיע" בלבד
    // (במנגנון הישן תווית ה-GR הוסתרה כאן)
    return <div className={endedCss}>{endedTxt}</div>;
});

// כפתור "אישור קבלה" - רכיב עצמאי עם טיק משלו, כדי שסף 10 הדקות
// ייבדק כל שנייה בלי re-render לכל שורת ההזמנה.
// עברו 10 דקות מהמועד -> מציגים; "בקשה לסגירה"/"בקשה לביטול" ->
// הלקוח כבר לחץ, מסתירים; סגור/מושהה/מבוטל -> מסתירים.
export const ConfirmReceiptBtn = memo(({ ord, wrapCss, onConfirm }) => {
    useSecondTick();

    if (ord.orderStatus === "בקשה לסגירה" || ord.orderStatus === "בקשה לביטול") {
        return null;
    }
    if (["סגור", "מושהה", "מבוטל"].includes(ord.orderStatus)) {
        return null;
    }

    const min10 = MyDateTime.getTimeLeftTilThen(
        ord.scheduledFor || ord.dateCreated,
        10
    );
    if (min10.theEnd !== true) {
        return null;
    }

    return (
        <div className={wrapCss}>
            <Button
                className={"myBtnWithIcon"}
                variant="outlined"
                startIcon={<CheckCircleOutline />}
                onClick={() => onConfirm(ord)}
            >
                <span className={"btnWithIconTxt"}>אישור קבלה</span>
            </Button>
        </div>
    );
});

export default MyOrderTimerCell;
